module.exports = __webpack_public_path__ + "static/img/bg-tr.12ed953c.png";